var _defs, _g, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "left"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 100
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "right"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 0,
    width: 50,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#left)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#b22234"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 100,
    height: 7.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 15.4,
    width: 100,
    height: 7.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 30.8,
    width: 100,
    height: 7.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 46.2,
    width: 100,
    height: 7.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 61.5,
    width: 100,
    height: 7.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 76.9,
    width: 100,
    height: 7.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 92.3,
    width: 100,
    height: 7.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 46,
    fill: "#3c3b6e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 5,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 5,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 5,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 5,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 5,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 10,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 10,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 10,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 10,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 15,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 15,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 15,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 15,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 20,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 20,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 20,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 20,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 25,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 25,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 25,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 25,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 25,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 30,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 30,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 30,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 30,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 35,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 35,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 35,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 35,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 35,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 40,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 40,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 40,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 40,
    r: 1.8
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#right)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 100,
    y2: 100,
    stroke: "#fff",
    strokeWidth: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 0,
    x2: 0,
    y2: 100,
    stroke: "#fff",
    strokeWidth: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 100,
    y2: 100,
    stroke: "#C8102E",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 0,
    x2: 0,
    y2: 100,
    stroke: "#C8102E",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 0,
    width: 16,
    height: 100,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 42,
    width: 100,
    height: 16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 0,
    width: 10,
    height: 100,
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 45,
    width: 100,
    height: 10,
    fill: "#C8102E"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    stroke: "rgba(255,255,255,0.3)",
    strokeWidth: 1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49,
    fill: "none",
    stroke: "#ddd",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flag-en.6a731e0cd4f5f7ffe3aa16470ebe3e6b.svg";
export { ForwardRef as ReactComponent };